import { render } from "./TestIOS.vue?vue&type=template&id=2a6fbe8c&scoped=true&ts=true"
import script from "./TestIOS.vue?vue&type=script&lang=ts"
export * from "./TestIOS.vue?vue&type=script&lang=ts"

import "./TestIOS.vue?vue&type=style&index=0&id=2a6fbe8c&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6fbe8c"]])

export default __exports__